document.addEventListener('click', async (event) => {
  const copyButton = event.target.closest('[data-st-copy-share]');
  const nativeButton = event.target.closest('[data-st-native-share]');
  if (!copyButton && !nativeButton) return;

  const shareBox = event.target.closest('[data-st-share-boxes]');
  if (!shareBox) return;

  const status = shareBox.querySelector('[data-st-share-status]');
  const shareUrl = shareBox.dataset.shareUrl || window.location.href;
  const shareTitle = shareBox.dataset.shareTitle || document.title;
  const shareText = shareBox.dataset.shareText || '';

  if (nativeButton && navigator.share) {
    try {
      await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
      if (status) status.textContent = 'Shared.';
    } catch (error) {
      if (status) status.textContent = '';
    }
    return;
  }

  try {
    await navigator.clipboard.writeText(shareUrl);
    if (status) status.textContent = 'Link copied.';
  } catch (error) {
    window.prompt('Copy this link:', shareUrl);
  }
});
